import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

function FormCard({ title, description, route, buttonName, eventImage, className }) {
  return (
    <Card 
      className={className}
      sx={{ 
        width: 320, // Fixed width
        height: 420, // Fixed height
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        overflow: 'hidden',
        transition: 'all 0.3s ease-in-out',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        backgroundColor: '#fafafa', // Lighter gray background
        border: '1px solid #f0f0f0',
        '&:hover': {
          boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <CardMedia
        component="img"
        sx={{
          height: 260, // Increased image height for better view
          width: '100%',
          objectFit: 'cover',
          backgroundColor: '#f8f8f8' // Very light gray for image placeholder
        }}
        image={eventImage}
        alt={title}
      />
      <CardContent 
        sx={{ 
          height: 160, // Reduced content height (420 - 260 = 160)
          display: 'flex',
          flexDirection: 'column',
          p: 2.5, // Slightly reduced padding
          justifyContent: 'space-between',
          backgroundColor: '#fafafa' // Lighter gray background
        }}
      >
        <Box>
          <Typography 
            variant="h6" 
            component="h3"
            sx={{ 
              fontWeight: 600,
              color: '#2c3e50',
              mb: 1.5,
              height: '2.8rem', // Reduced title height
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: 1.2,
              fontSize: '1.1rem'
            }}
          >
            {title}
          </Typography>
          
          {description && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                height: '2.5rem', // Reduced description height
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2, // Reduced to 2 lines
                WebkitBoxOrient: 'vertical',
                lineHeight: 1.3,
                mb: 1.5,
                fontSize: '0.85rem'
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
        
        <Button 
          component={Link} 
          to={route} 
          variant="contained" 
          fullWidth
          size="medium"
          sx={{
            height: '44px', // Slightly smaller button height
            borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            boxShadow: '0 3px 12px rgba(102, 126, 234, 0.3)',
            textTransform: 'none',
            fontSize: '0.95rem',
            fontWeight: 600,
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              boxShadow: '0 5px 18px rgba(102, 126, 234, 0.5)',
              transform: 'translateY(-1px)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          {buttonName}
        </Button>
      </CardContent>
    </Card>
  );
}

export default FormCard;